export const END_POINTS = {
  //GET
  paymentDetails: 'v1/web/payments/:paymentExternalId/checkout/detail',
  storeDetails: 'v1/web/plugin-platforms/astropay_pro/stores/:storeTag',
  paymentLinkDetails: 'v1/web/payment-links/:paymentLinkId',

  //POST
  createPayment: 'v1/web/payments',
};
